import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=5e1ba309&scoped=true&"
import script from "./PersonalData.vue?vue&type=script&lang=js&"
export * from "./PersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1ba309",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/PersonalData.vue
// module id = 620
// module chunks = 3